"use strict";
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FillingButton = void 0;
const Block_1 = require("./Block");
const Global_1 = require("../Global");
const ui_1 = require("@pixi/ui");
const gsap_1 = require("gsap");
const WigglyText_1 = require("../objects/WigglyText");
const settings_1 = require("../config/settings");
class FillingButton extends Block_1.Block {
    constructor(app, w = 150, h = 60, b = settings_1.Settings.whiteColor, f = settings_1.Settings.lightGrayColor, rounded = true) {
        super(app);
        this.w = w;
        this.h = h;
        this.b = b;
        this.f = f;
        this.rounded = rounded;
        this.bar = this.makeLoading();
    }
    timeline(duration = 3) {
        const tmbar = gsap_1.gsap.timeline()
            .to({}, {
            onUpdate: () => {
                try {
                    const cur = tmbar.progress() * 100;
                    this.bar.progress = (0, Global_1.isrtl)() ? 100 - cur : cur;
                }
                catch (e) { }
            },
            ease: 'none',
            duration: duration
        }, 's');
        return tmbar;
    }
    setText(t, style = null) {
        if (!this.txt) {
            this.txt = new WigglyText_1.WigglyText(this.app, t, style ? style : Block_1.Block.textStyle(32));
            this.txt.anchor.set(0.5);
            this.txt.position.y = (0, Global_1.px)(4);
            this.addChild(this.txt);
        }
        else {
            this.txt.text = t;
            if (style) {
                this.txt.style = style;
            }
        }
        return this.txt;
    }
    makeLoading() {
        const options = {
            height: this.h,
            width: this.w,
            border: 2,
            radius: this.rounded ? this.h / 2 : 3,
            borderColor: this.rounded ? settings_1.Settings.grayColor : 0x222222
        };
        const bg = this.makeBox(Object.assign(Object.assign({}, options), {
            backgroundColor: (0, Global_1.isrtl)() ? this.f : this.b
        }));
        const fill = this.makeBox(Object.assign(Object.assign({}, options), {
            backgroundColor: (0, Global_1.isrtl)() ? this.b : this.f
        }));
        const bar = new ui_1.ProgressBar({
            bg, fill, progress: (0, Global_1.isrtl)() ? 100 : 0
        });
        bar.pivot.set(bar.width / 2, bar.height / 2);
        return this.addChild(bar);
    }
}
exports.FillingButton = FillingButton;
